// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"ba98fa75","186":"24d4ce2a","435":"fc51d4a2","473":"127e58cc","534":"a44040b8","645":"71b4ad4e","859":"f86d4fe7","874":"95017475"}[chunkId] + ".chunk.js";
};